import { createVNode as e, mergeProps as a } from "vue";
import d from "../node_modules/@pf-ui/pf-icon-svg/es/asn/AccountGroupOutlinedStandard.js";
import u from "../components/PfIcon.js";
const t = (r, o) => {
  const n = {
    ...r,
    ...o.attrs
  };
  return e(u, a(n, {
    icon: d
  }), null);
};
t.displayName = "AccountGroupOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
